module.exports = __webpack_public_path__ + "img/qr_ghxyr.acc20128.png";